<template>
  <div class="contentPadding">
    <a-form layout="inline">
      <a-form-item label="文章标题">
        <a-input
          placeholder="请输入"
          v-model:value="searchform.docTitle"
          allow-clear
        />
      </a-form-item>
      <a-form-item label="标签">
        <a-select
            v-model:value="searchform.labId"
            placeholder="请选择"
            style="width:200px;"
            show-search
            option-filter-prop="children"
            :filter-option="filterOption"
            :disabled="isShow"
            allowClear
          >
            <a-select-option
              v-for="(item,index) in tabAllList"
              :value="item.id"
              :key="index"
              >{{ item.labName+'' }}</a-select-option
            >
          </a-select>
      </a-form-item>
      <a-form-item label="状态">
        <a-select
          placeholder="请选择"
          style="width: 180px"
          v-model:value="searchform.status"
          allow-clear
        >
          <a-select-option value="0">暂存</a-select-option>
          <a-select-option value="1">已发布</a-select-option>
          <a-select-option value="2">未发布</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :wrapper-col="{ offset: 20 }">
        <a-button
          type="primary"
          @click="onSearch"
          v-if="isShowBtn('sys:article:select')"
        >
          查询
        </a-button>
      </a-form-item>
      <a-form-item :wrapper-col="{ offset: 15 }">
        <a-button style="margin-left: 10px" @click="onReset"> 重置 </a-button>
      </a-form-item>
    </a-form>
    <a-row class="buttonGroup">
      <a-button type="primary" class="btnMargin" @click="toAdd">
        <PlusOutlined />新建
      </a-button>
    </a-row>
    <a-table
      :row-selection="rowSelection"
      :data-source="articlelist"
      row-key="id"
      :pagination="pagination"
      @change="changeTable"
    >
      <a-table-column
        key="id"
        title="文章ID"
        data-index="id"
        align="center"
      />
      <a-table-column
        key="docTitle"
        title="文章标题"
        data-index="docTitle"
        align="center"
        :ellipsis="true"
      />
      <a-table-column
        key="articleLabs"
        data-index="articleLabs"
        title="标签"
        align="center"
      />
      <a-table-column
        key="realNumber"
        title="点击量"
        data-index="realNumber"
        align="center"
      />
      <a-table-column
        key="pushTime"
        title="发布时间"
        align="center"
      >
      <template v-slot="scope">
          <span>
            {{scope.text.status == 1 ? scope.text.pushTime : '--'}}
          </span>
        </template>
      </a-table-column>
      <a-table-column
        key="updateTime"
        title="更新时间"
        data-index="updateTime"
        align="center"
      />
      <a-table-column key="status" title="状态" align="center">
        <template v-slot="scope">
          <span>
            <a-tag v-if="scope.text.status == 0"> 暂存 </a-tag>
            <a-tag v-else-if="scope.text.status == 1">已发布 </a-tag>
            <a-tag v-else-if="scope.text.status == 2">未发布 </a-tag>
          </span>
        </template>
      </a-table-column>
      <a-table-column key="action" title="操作" align="center" :width="300">
        <template v-slot="scope">
          <span>
            <a-button
              type="link"
              @click="handlePush(scope.text.id)"
              v-if="scope.text.status == 2 && isShowBtn('sys:article:push')"
            >
              发布
            </a-button>
            <a-button
              type="link"
              @click="handleEdit(scope.record)"
              v-if="isShowBtn('sys:article:update')"
            >
              编辑
            </a-button>
            <a-button
              type="link"
              @click="handleTop(scope.record)"
              v-show="scope.text.istop == 0 && isShowBtn('sys:article:addTop')"
            >
              置顶
            </a-button>
            <a-button
              type="link"
              @click="handleRemoveTop(scope.record)"
              v-show="
                scope.text.istop == 1 && isShowBtn('sys:article:removeTop')
              "
            >
              取消置顶
            </a-button>
            <a-button
              type="link"
              @click="handleDel(scope.text.id)"
              v-if="isShowBtn('sys:article:delete')"
            >
              删除
            </a-button>
          </span>
        </template>
      </a-table-column>
    </a-table>
    <info
      :info="info"
      ref="dialog"
      @onSubmit="searchArticleList"
      :picCode="picCode"
      @clearPicCode="clearPicCode"
    />
  </div>
  <div></div>
</template>
<script>
import info from "./info";
import { PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { createVNode, nextTick } from "vue";
import { message, Modal, notification } from "ant-design-vue";
import { isShowBtn } from "../../../until/tool";
const defaultSearchform = {
  docTitle: "",
  labId: "",
  status: null,
  articleTypeId: null,
  pageIndex: 1,
  pageSize: 10
};
export default {
  name: "",
  props: {},
  data() {
    return {
      tabAllList:[],
      searchform: {
        docTitle: "",
        labId: "",
        status: null,
        articleTypeId: null,
        pageIndex: 1,
        pageSize: 10
      },
      newTypeId: null,
      info: {
        isAdd: true,
        isEdit: false,
        isShow: false
      },
      loading: false,
      picCode: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10, //每页中显示10条数据
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ["5", "10", "30"], //每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
      }
    };
  },
  computed: {
    ...mapGetters({
      articlelist: "news/articlelist",
      articletypename: "news/articletypename",
      articletypelist: "news/articletypelist",
      pageIndex: "news/pageIndex",
      pageSize: "news/pageSize",
      total: "news/total"
    }),
    rowSelection() {
      return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange: (selectedRowKeys, selectedRows) => {}
      };
    }
  },
  watch: {},
  methods: {
    isShowBtn,
    ...mapMutations({
      SET_PAGEINDEX: "news/SET_PAGEINDEX",
      SET_PAGESIZE: "news/SET_PAGESIZE",
      SET_ARTICLELIST: "news/SET_ARTICLELIST"
    }),
    ...mapActions({
      SearchArticleList: "news/SearchArticleList",
      DeleteById: "news/DeleteById",
      AddTop: "news/AddTop",
      RemoveTop: "news/RemoveTop",
      SelectArticleTypeById: "news/SelectArticleTypeById",
      SelectArticleTypeList: "news/SelectArticleTypeList",
      PushArticle: "news/PushArticle"
    }),
    // 过滤搜索
    filterOption(input, option) {
      return (
        option.children[0].children
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getAllTabList() {
      this.$store
        .dispatch("ListSyslab")
        .then(res => {
          if (res.code === 0) {
            this.tabAllList = res.data;
            console.log('taball',this.tabAllList)
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 分页、排序、筛选变化时触发
    changeTable(pagination, filters, sorter) {
      this.searchform.pageIndex = pagination.current;
      this.searchform.pageSize = pagination.pageSize;
      this.searchArticleList();
    },
    // 情况picCode
    clearPicCode(){
      console.log('....clearPicCodeclearPicCodeclearPicCode')
      this.picCode=""
    },
    searchArticleList() {
      this.loading = true;
      this.SearchArticleList(this.searchform)
        .then(res => {
          if (res.code === 0) {
            if (
              res.data.currPage > res.data.totalPage &&
              res.data.totalPage !== 0
            ) {
              this.searchform.pageIndex = res.data.totalPage;
              this.searchArticleList();
            } else {
              this.searchform.pageIndex = res.data.currPage;
            }
            res.data.list.forEach(item => {
              item.realNumber = (item.clickNumber ? item.clickNumber : 0) + (item.realNumber ? item.realNumber : 0);
            });
            this.SET_ARTICLELIST(res.data.list);
            this.searchform.pageSize = res.data.pageSize;
            this.pagination.current = res.data.currPage;
            this.pagination.pageSize = res.data.pageSize;
            this.pagination.total = res.data.totalCount;
            this.loading = false;
          } else {
            this.loading = false;
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getPicCode() {
      this.$store
        .dispatch("news/GetAttachmentCode")
        .then(res => {
          this.picCode = res;
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    toAdd() {
      this.info.isAdd = this.info.isShow = true;
      this.info.isEdit = false;
      this.$refs.dialog.imgUrl = [];
      this.$refs.dialog.fileList = [];
      this.$refs.dialog.dataObj = {};
      this.$refs.dialog.tabArr=[]
      this.$refs.dialog.tabValue=""
      this.getPicCode();
      // 添加时获取列表图片的code
      this.$refs.dialog.getAddListImgCode();
      setTimeout(() => {
        this.$refs.dialog.resetForm();
        this.$refs.dialog.addClearForm();
        console.log(this.$refs.dialog.articleform, ".....");
      }, 100);
    },
    handleEdit(data) {
      this.info.isAdd = false;
      this.info.isEdit = true;
      this.info.isShow = true;
      this.getPicCode();
      setTimeout(() => {
        this.$refs.dialog.resetForm();
        this.$refs.dialog.setinfo(data);
      }, 100);
    },
    onSearch() {
      this.searchArticleList();
    },
    onReset() {
      this.searchform = { ...defaultSearchform };
      this.searchArticleList();
    },
    handlePush(data) {
      this.PushArticle(data)
        .then(() => {
          message.success("发布文章成功");
          this.searchArticleList();
        })
        .catch(() => {
          message.error("发布失败");
          this.searchArticleList();
        });
    },

    // 删除一条数据
    handleDel(id) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      Modal.confirm({
        title: "确认删除",
        icon: createVNode(ExclamationCircleOutlined),
        content: "删除操作不可撤销，请谨慎操作。",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          self
            .DeleteById(id)
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: "已删除"
                });
                self.searchArticleList();
              } else {
                self.$message.error(res.msg);
              }
            })
            .catch(err => {
              self.$message.error(err);
            });
        }
      });
    },
    handleTop(data) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      this.AddTop(data.id)
        .then(res => {
          if (res.code === 0) {
            notification["success"]({
              message: "置顶成功"
            });
            self.searchArticleList();
          } else {
            notification["error"]({
              message: "置顶失败"
            });
            self.$message.error(res.msg);
          }
        })
        .catch(err => {
          self.$message.error(err);
        });
    },
    handleRemoveTop(data) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      this.RemoveTop(data.id)
        .then(res => {
          if (res.code === 0) {
            notification["success"]({
              message: "取消置顶成功"
            });
            self.searchArticleList();
          } else {
            notification["fail"]({
              message: "取消置顶失败"
            });
            self.$message.error(res.msg);
          }
        })
        .catch(err => {
          self.$message.error(err);
        });
    }
  },
  created() {
    console.log("...create");
    this.searchArticleList();
    this.getAllTabList()
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  mounted() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  beforeUnmount() {},
  components: {
    info,
    PlusOutlined,
    // eslint-disable-next-line vue/no-unused-components
    ExclamationCircleOutlined
  },
  filters: {}
};
</script>
<style lang="scss" scoped>
.btnMargin {
  margin-right: 10px;
}
</style>
